import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/ApplyFor.css";
import { cl1 } from "../../Constant";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMarker,
    faPencil,
    faToggleOn,
    faUsd,
} from "@fortawesome/free-solid-svg-icons";
import config from "../../config";
import { Link } from "react-router-dom";
import moment from "moment";

const Profile = ({ auth }) => {
    return (
        <>
            <Header />
            <section className="review">
                <div className="container">
                    <div id="livesearch"></div>
                    <div className="row">
                        <div className="col-md-8">
                            <div
                                className="d-flex"
                                style={{
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                }}
                            >
                                <div className="profile-pic-section">
                                    <img
                                        id="profile_picture1"
                                        className="profile-pic"
                                        src={config.returnImage(auth.user)}
                                    />
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="d-flex">
                                        <h5
                                            id="username"
                                            className="mt-2 mb-0 user-name blue"
                                        >
                                            {auth.user.full_name}
                                        </h5>
                                    </span>
                                    {/* <span className="user-info"> */}
                                    <span id="country" className="user-country">
                                        {auth.user.country}
                                    </span>
                                    {/* </span> */}
                                    {/* <p
                                        id="main-category"
                                        className="user-service color-red mb-2 m-0"
                                    >
                                        {auth.user.role == 2 &&
                                            auth.user.services[0]?.service
                                                .title}
                                    </p> */}
                                    <p
                                        id="care-giverBio"
                                        className="user-description"
                                    >
                                        {auth.user.bio}
                                    </p>
                                </div>
                            </div>
                            <div
                                id="user-sub-service"
                                className="tags user-sub-service"
                            >
                                <span className="review-tags d-none">
                                    {auth.user.services?.length > 0 &&
                                    auth.user.services[0].service_types
                                        ?.length > 0
                                        ? auth.user.services[0]
                                              ?.service_types[0]
                                        : null}
                                </span>
                            </div>
                        </div>
                        <div className="col-md-1">
                            <div className="switch">
                                <a
                                    href="#;"
                                    className="changeStatus"
                                    id="changeStatus"
                                >
                                    <FontAwesomeIcon
                                        icon={faToggleOn}
                                        className="statusIcon"
                                    />
                                    {/* <i
                                        className="statusIcon fa fa-toggle-on"
                                        aria-hidden="true"
                                    ></i> */}
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 boarding-section">
                            {auth.user.role == 2 &&
                            auth.user.on_board &&
                            auth.user.is_on_board == 0 ? (
                                <>
                                    <a
                                        id="onBoarding-btn"
                                        target="_blank"
                                        href={auth.user.on_board}
                                        className="btn btn-secondary"
                                    >
                                        Complete onboarding
                                    </a>
                                    <p
                                        id="stripeSection"
                                        className="status-stripe-p mt-2"
                                    >
                                        <span>Stripe Status </span>
                                        <span className="stripeStatus">
                                            {auth.user.is_on_board == 1
                                                ? "Active"
                                                : "Inactive"}
                                        </span>{" "}
                                    </p>
                                </>
                            ) : null}

                            {auth.user.role == 2 &&
                            auth.user.checkr_link &&
                            auth.user.checkr_status == "Pending" &&
                            auth.user.checkr_report_id == null ? (
                                <a
                                    id="onBoarding-btn"
                                    target="_blank"
                                    href={auth.user.checkr_link}
                                    className="btn btn-secondary"
                                >
                                    Complete Checkr Verification
                                </a>
                            ) : null}
                            {auth.user.role == 2 ? (
                                <p id="stripeSection" className="mt-2">
                                    <span>Checkr Status </span>
                                    <span className="stripeStatus">
                                        {auth.user.checkr_status != "Pending"
                                            ? "Active"
                                            : "Inactive"}
                                    </span>{" "}
                                </p>
                            ) : null}
                        </div>
                    </div>
                    <hr />
                    <section className="proflerev padding-prof">
                        <div className="row">
                            <div className="col-md-6">
                                <h4>Basic Information</h4>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-end">
                                    <Link
                                        to="/edit-profile"
                                        className="btn btn-defualt-1"
                                    >
                                        {" "}
                                        <FontAwesomeIcon icon={faPencil} /> Edit
                                        Profile
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-md-12">
                                <h4>Basic Information</h4>
                            </div>
                        </div> */}
                        <div className="row py-2">
                            <div className="col-md-6">
                                <p>First Name</p>
                                <span id="first_name" className="blue">
                                    {auth.user.first_name}
                                </span>
                            </div>
                            <div className="col-md-6">
                                <p>Last name</p>
                                <span id="last_name" className="blue">
                                    {auth.user.last_name}
                                </span>
                            </div>
                        </div>
                        <div className="row py-2">
                            <div className="col-md-6">
                                <p>Address</p>
                                <span id="address" className="blue">
                                    {auth.user.address_1}
                                </span>
                            </div>
                            <div className="col-md-6">
                                <p>City</p>
                                <span id="city" className="blue">
                                    {auth.user.city}
                                </span>
                            </div>
                        </div>
                        <div className="row py-4">
                            <div className="col-md-6">
                                <p>Country</p>
                                <span
                                    id="user-country"
                                    className="blue user-country"
                                >
                                    {auth.user.country}
                                </span>
                            </div>
                            <div className="col-md-6">
                                <p>State</p>
                                <span id="user-state" className="blue">
                                    {auth.user.state_name}
                                </span>
                            </div>
                        </div>
                        <div className="row py-4">
                            <div className="col-md-6">
                                <p>Date of Birth</p>
                                <span id="dob" className="blue">
                                    {auth.user.dob
                                        ? moment(auth.user.dob).format(
                                              "DD MMM, YYYY"
                                          )
                                        : "N/A"}
                                </span>
                            </div>
                            <div className="col-md-6">
                                <p>Gender</p>
                                <span id="gender" className="blue">
                                    {auth.user.gender == 1 ? "Female" : "Male"}
                                </span>
                            </div>
                        </div>
                        <div className="row py-4">
                            <div className="col-md-6">
                                <p>Zipcode</p>
                                <span id="zip" className="blue">
                                    {auth.user.zip}
                                </span>
                            </div>
                        </div>

                        {/* <div className="row py-4">
                            <div className="col-md-6">
                                <p>Weight</p>
                                <span id="user-weight" className="blue">
                                    {auth.user.weight}
                                </span>
                            </div>
                            <div className="col-md-6">
                                <p>Height</p>
                                <span id="height" className="blue">
                                    {auth.user.height}
                                </span>
                            </div>
                        </div> */}
                        <div className="row">
                            <div className="col-md-12">
                                <h4>Contact Information</h4>
                            </div>
                        </div>
                        <div className="row py-4">
                            <div className="col-md-6">
                                <p>Email Address</p>
                                <span id="email" className="blue">
                                    <span
                                        id="email_verified_at"
                                        className="green"
                                    >
                                        {auth.user.email}
                                    </span>
                                </span>
                            </div>
                            <div className="col-md-6">
                                <p>Phone</p>
                                <span id="phone_no" className="blue">
                                    {auth.user.phone_no}
                                </span>
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-md-12">
                                <h4>Services Details</h4>
                            </div>
                        </div>
                        <div className="row py-4">
                            <div className="col-md-6">
                                <p>Main Category</p>
                                <span
                                    id="main-category"
                                    className="service blue user-service"
                                ></span>
                            </div>
                            <div className="col-md-6">
                                <p>Sub Category</p>
                                <div
                                    id="suggesstion-box"
                                    className="tags user-sub-service"
                                >
                                    <span className="review-tags d-none">
                                        Kids trainer
                                    </span>
                                </div>
                            </div>
                        </div> */}
                    </section>
                </div>
            </section>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
